"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageTypeCard = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var definitions_1 = require("../../../hooks/definitions");
function LineOfCoverageTypeCard(_a) {
    var _b;
    var lineOfCoverage = _a.lineOfCoverage, onRemove = _a.onRemove, onDisplayNameChange = _a.onDisplayNameChange, index = _a.index;
    var renderLineOfCoverageType = definitions_1.useDefinitionsHelpers().renderLineOfCoverageType;
    var readableName = renderLineOfCoverageType(lineOfCoverage.type);
    var existentLoc = !!lineOfCoverage.uuid;
    return (react_1.default.createElement(StyledRow, null,
        react_1.default.createElement(StyledActionMenu, { className: "card-menu" },
            react_1.default.createElement(core_ui_1.Tooltip, { text: existentLoc ? 'Delete coverage' : 'Deselect coverage', positionTip: "left" },
                react_1.default.createElement(core_ui_1.IconButton, { type: existentLoc ? 'remove' : 'close', 
                    // if loc contains uuid, it means we're deleting an existent loc
                    onClick: function () { return onRemove(index, !!existentLoc); } }))),
        react_1.default.createElement(core_ui_1.Padding, { size: 16, right: 20 },
            react_1.default.createElement(core_ui_1.Stack, { gap: 4, direction: "vertical" },
                react_1.default.createElement(core_ui_1.Text, { weight: 600, color: "dark", truncate: true },
                    react_1.default.createElement(core_ui_1.LineClamp, { numOfLines: 2 }, readableName)),
                react_1.default.createElement(core_ui_1.Text, null,
                    react_1.default.createElement(core_ui_1.LineClamp, { numOfLines: 2 },
                        react_1.default.createElement(core_ui_1.Input, { type: "text", style: {
                                border: 0,
                                padding: 0,
                                height: 18,
                            }, value: (_b = lineOfCoverage.displayName) !== null && _b !== void 0 ? _b : '', placeholder: "Add a display name...", onChange: function (displayName) { return onDisplayNameChange(index, displayName); } })))))));
}
exports.LineOfCoverageTypeCard = LineOfCoverageTypeCard;
var StyledActionMenu = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 10;\n"], ["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 10;\n"])));
var StyledRow = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: white;\n  border: 1px solid ", ";\n  border-radius: 6px;\n  position: relative;\n"], ["\n  background-color: white;\n  border: 1px solid ", ";\n  border-radius: 6px;\n  position: relative;\n"])), core_ui_1.colors.steel[200]);
var templateObject_1, templateObject_2;
